/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ContractTemplateSignaturePermissionMode = "A_1" | "A_2" | "A_3" | "%future added value";
export type ContractTemplateState = "A_1" | "A_2" | "A_3" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractTemplateDetails_template$ref: FragmentReference;
declare export opaque type ContractTemplateDetails_template$fragmentType: ContractTemplateDetails_template$ref;
export type ContractTemplateDetails_template = {|
  +id: string,
  +name: string,
  +state: ContractTemplateState,
  +activationDate: ?any,
  +created: any,
  +docxFileName: string,
  +docxFileUrl: ?string,
  +samplePdfFileUrl: ?string,
  +createdBy: ?{|
    +fullName: ?string,
    +representativeImageUrl: ?string,
  |},
  +categories: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |},
  +signaturePermissionMode: ContractTemplateSignaturePermissionMode,
  +allowedSigners: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +user: {|
          +fullName: ?string
        |},
      |}
    |}>
  |},
  +specificSigners: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +user: {|
          +fullName: ?string
        |},
      |}
    |}>
  |},
  +contractValueLimitEnabled: boolean,
  +contractValueLimit: ?number,
  +signerOverrides: ?$ReadOnlyArray<?{|
    +id: ?string,
    +staff: ?{|
      +id: string,
      +user: {|
        +fullName: ?string
      |},
    |},
    +contractValueLimit: ?any,
  |}>,
  +$refType: ContractTemplateDetails_template$ref,
|};
export type ContractTemplateDetails_template$data = ContractTemplateDetails_template;
export type ContractTemplateDetails_template$key = {
  +$data?: ContractTemplateDetails_template$data,
  +$fragmentRefs: ContractTemplateDetails_template$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "user",
    "storageKey": null,
    "args": null,
    "concreteType": "UserNode",
    "plural": false,
    "selections": [
      (v2/*: any*/)
    ]
  }
],
v4 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "StaffNodeEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "StaffNode",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contractValueLimit",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContractTemplateDetails_template",
  "type": "ContractTemplateNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "activationDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "created",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "docxFileName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "docxFileUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "samplePdfFileUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "createdBy",
      "storageKey": null,
      "args": null,
      "concreteType": "StaffNode",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "representativeImageUrl",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categories",
      "storageKey": "categories(orderBy:\"name\")",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "name"
        }
      ],
      "concreteType": "CategoryNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CategoryNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CategoryNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "signaturePermissionMode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "allowedSigners",
      "storageKey": null,
      "args": null,
      "concreteType": "StaffNodeConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "specificSigners",
      "storageKey": null,
      "args": null,
      "concreteType": "StaffNodeConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contractValueLimitEnabled",
      "args": null,
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "signerOverrides",
      "storageKey": null,
      "args": null,
      "concreteType": "SignerOverrideType",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "staff",
          "storageKey": null,
          "args": null,
          "concreteType": "StaffNode",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        (v5/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '64e9530f21405000bf0b986a1c469503';
module.exports = node;
